import React__default from 'react';
import { Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import KButton from '../../KButtons/index.js';

var BasketsEmptyState = function (_a) {
    var hasFilters = _a.hasFilters, resetFilters = _a.resetFilters, _b = _a.testId, testId = _b === void 0 ? "BasketsEmptyState" : _b;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(Container, { "data-testid": testId, sx: {
            paddingTop: 4,
            paddingBottom: 4,
            textAlign: "center"
        } },
        hasFilters && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Typography, { sx: {
                    marginBottom: 2
                }, variant: "h4" }, t("components.baskets.empty-state.title")),
            React__default.createElement(Typography, { sx: {
                    marginBottom: 1
                } }, t("components.baskets.empty-state.description")),
            React__default.createElement(KButton, { className: "EmptyState-ResetButton", color: "primary", onClick: resetFilters, variant: "outlined" }, t("components.baskets.empty-state.remove-filters")))),
        !hasFilters && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Typography, { sx: {
                    marginBottom: 2
                }, variant: "h4" }, t("components.baskets.empty-state.no-baskets"))))));
};

export { BasketsEmptyState as default };
//# sourceMappingURL=index.js.map
